var map = {
	"./Anagrafica_Agenti/en.json": 35108,
	"./Anagrafica_Agenti/it.json": 61366,
	"./Anagrafica_Agenti/procedures.json": 32584,
	"./B2C_Discount/procedures.json": 24327,
	"./Catalog_Img/procedures.json": 6385,
	"./Catalog_Settings/procedures.json": 50642,
	"./Change_Order_Customer/procedures.json": 9670,
	"./Consegne/en.json": 19133,
	"./Consegne/it.json": 13600,
	"./Consegne/procedures.json": 3599,
	"./Etichette/en.json": 4409,
	"./Etichette/it.json": 72618,
	"./Etichette/procedures.json": 95912,
	"./Heich_Etichette/en.json": 5729,
	"./Heich_Etichette/it.json": 58930,
	"./Heich_Etichette/procedures.json": 31034,
	"./HomePage/procedures.json": 44505,
	"./Info_prodotto/procedures.json": 80919,
	"./Login/en.json": 79090,
	"./Login/it.json": 86270,
	"./Login/procedures.json": 39782,
	"./LoginUtility/procedures.json": 22636,
	"./Magazzino_Moda/en.json": 18035,
	"./Magazzino_Moda/it.json": 12960,
	"./Magazzino_Moda/procedures.json": 62454,
	"./Stagioni_ClienteB2B/procedures.json": 1075,
	"./Tabella_AlberoMerceologico/procedures.json": 5253,
	"./Tabella_EccezioniArticoliB2B/procedures.json": 99731,
	"./Tabella_GrigliaPromoB2B/procedures.json": 1290,
	"./Tabella_MasterFileWEB/procedures.json": 52034,
	"./Tabella_MasterFileWEB_descrizioni/procedures.json": 65608,
	"./Tabella_PeriodiConsegne/en.json": 10026,
	"./Tabella_PeriodiConsegne/it.json": 22457,
	"./Tabella_PeriodiConsegne/procedures.json": 11150,
	"./Tabella_Presentazioni/procedures.json": 9795,
	"./Tabella_Promozioni/procedures.json": 54476,
	"./Tabella_Stagioni/en.json": 64566,
	"./Tabella_Stagioni/it.json": 41867,
	"./Tabella_Stagioni/procedures.json": 14053,
	"./Temporanea_Clienti/en.json": 75288,
	"./Temporanea_Clienti/it.json": 56567,
	"./Temporanea_Clienti/procedures.json": 16117,
	"./Temporanea_Etichette_ordini/en.json": 25780,
	"./Temporanea_Etichette_ordini/it.json": 62955,
	"./Temporanea_Etichette_ordini/procedures.json": 84247,
	"./Temporanea_ModuloCassa/en.json": 54016,
	"./Temporanea_ModuloCassa/it.json": 22238,
	"./Temporanea_Prodotti/en.json": 77118,
	"./Temporanea_Prodotti/it.json": 70489,
	"./Temporanea_Prodotti/procedures.json": 33249,
	"./Testate_AOrdiniAnn/en.json": 95156,
	"./Testate_AOrdiniAnn/it.json": 5473,
	"./Testate_AOrdiniAnn/procedures.json": 88040,
	"./privacy/procedures.json": 62420,
	"./zSys_Sites_Settings/procedures.json": 87028,
	"./zSys_Users/en.json": 34545,
	"./zSys_Users/it.json": 89096,
	"./zSys_Users/procedures.json": 58714
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98016;
module.exports = webpackAsyncContext;